import { render, staticRenderFns } from "./ModalViewImage.vue?vue&type=template&id=352d1802&"
import script from "./ModalViewImage.vue?vue&type=script&lang=js&"
export * from "./ModalViewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports